import * as React from 'react';
import { AppBar, styled } from '@mui/material';
import { CoreBox, CoreTypography } from '@youscience/core';

export const HeaderFallback: React.FC = () => (
  <AppBar sx={{ backgroundColor: '#FFF', width: '100%', border: '2px dashed #D33131' }}>
    <CoreBox sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem' }}>
      <CoreTypography sx={{ color: 'text.secondary' }} variant="h5" component="h4">
        YouScience Header
      </CoreTypography>
      <CoreTypography sx={{ color: 'error.main' }}>
        This is a placeholder for failed import of the federated header.
      </CoreTypography>
    </CoreBox>
  </AppBar>
);

const StyledFooter = styled('footer')(({ theme }) => ({
  display: 'flex',
  padding: '1rem 5.25rem .9375rem',
  color: theme.palette.grey[700],
  border: '2px dashed #D33131',

  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    flexDirection: 'column',
  },
}));

export const FooterFallback: React.FC = () => (
  <StyledFooter>
    <CoreTypography sx={{ color: 'error.main' }}>
      This is a placeholder for failed import of the federated footer.
    </CoreTypography>
  </StyledFooter>
);

export const FederatedModuleFallback: React.FC = () => (
  <CoreBox sx={{ padding: 4, border: '1px solid #eee' }}>Unable to load federated content</CoreBox>
);
